import { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFileDownload,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'

import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import AwesomeFileInput from 'components/ui/forms/field/awesomeFileInput/AwesomeFileInput'

import styles from './UploadFileV2.module.scss'

type UploadFileV2Props = {
  title: string
  onClose: () => void
  labels: {
    close: string
    inputPlaceholder: string
  }
  onUpload: (file: File) => void
  error: ReactNode
  children?: ReactNode
  template?: {
    link: string
    label: string
  }
  help?: {
    link: string
    label: string
  }
}

export function UploadFileV2({
  title,
  onClose,
  labels,
  onUpload,
  error,
  children,
  template,
  help,
}: UploadFileV2Props) {
  const handleFileUpload = (file: File) => {
    if (file) {
      onUpload?.(file)
    }
  }

  return createPortal(
    <Modal
      title={title}
      maxheight={460}
      maxwidth={800}
      close={onClose}
      actions={
        <ModalButtons secondaryText={labels.close} secondaryAction={onClose} />
      }
    >
      <div>
        {children && <div>{children}</div>}
        <AwesomeFileInput
          multiFile={false}
          onChange={([newFile]) => {
            handleFileUpload(newFile)
          }}
          className="mt-3"
          error={!!error}
          labels={{
            emptyState: {
              title: labels.inputPlaceholder,
            },
          }}
        />
        {error && (
          <p
            className={classNames(
              'lead small text-danger text-center mt-2',
              styles.fileError
            )}
          >
            {error}
          </p>
        )}
        {(template || help) && (
          <div className={styles.additionalContainer}>
            {template && (
              <a target="_blank" rel="noreferrer" href={template.link}>
                <FontAwesomeIcon icon={faFileDownload} />
                <span>{template.label}</span>
              </a>
            )}
            {help && (
              <a target="_blank" rel="noreferrer" href={help.link}>
                <FontAwesomeIcon icon={faQuestionCircle} />
                <span>{help.label}</span>
              </a>
            )}
          </div>
        )}
      </div>
    </Modal>,
    document.body
  )
}
